import { render } from "./Select.vue?vue&type=template&id=8b244862&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=8b244862&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b244862"

export default script